import { FirestoreCollectionHandler } from '@services/firebase/firestore/collectionHandler';
import { log } from '@utils/log';
import {
  Approval,
  AuditLog,
  AuditTrail,
  Campaign,
  Category,
  ChatSession,
  Collaborator,
  collectionMap,
  CollectionMap,
  CollectionRef,
  collectionRef,
  Config,
  DataPool,
  EmailTemplate,
  Entity,
  EventLog,
  Expression,
  FilestoreItem,
  Form,
  FormGroup,
  FormModel,
  GroupEntity,
  Hop,
  InvitationEnvelope,
  List,
  Member,
  OrgNode,
  Reminder,
  Report,
  Role,
  Solver,
  SolverResult,
  SurveyResponse,
  Table,
  Tag,
  Task,
  TextWidget,
  Theme,
  User,
  UserGroup,
  Workflow
} from '@vincerosoft/assessfluence-types';
import { DocumentData } from 'firebase/firestore';

class FirestoreCollectionManagerFactory {
  constructor() {}

  create<DbModelType extends DocumentData>(
    collectionName: keyof CollectionMap
  ): FirestoreCollectionHandler<DbModelType> {
    return new FirestoreCollectionHandler<DbModelType>(collectionName);
  }
}

class CollectionsService {
  collectionManagerFactory = new FirestoreCollectionManagerFactory();
  approvals!: FirestoreCollectionHandler<Approval>;
  forms!: FirestoreCollectionHandler<Form>;
  formGroups!: FirestoreCollectionHandler<FormGroup>;
  auditLogs!: FirestoreCollectionHandler<AuditLog<unknown>>;
  auditTrails!: FirestoreCollectionHandler<AuditTrail>;
  chatSessions!: FirestoreCollectionHandler<ChatSession>;
  campaigns!: FirestoreCollectionHandler<Campaign>;
  categories!: FirestoreCollectionHandler<Category>;
  collaborators!: FirestoreCollectionHandler<Collaborator>;
  dataPools!: FirestoreCollectionHandler<DataPool>;
  emails!: FirestoreCollectionHandler<EmailTemplate>;
  entities!: FirestoreCollectionHandler<Entity>;
  eventLogs!: FirestoreCollectionHandler<EventLog>;
  expressions!: FirestoreCollectionHandler<Expression>;
  files!: FirestoreCollectionHandler<FilestoreItem>;
  formModels!: FirestoreCollectionHandler<FormModel>;
  groupEntities!: FirestoreCollectionHandler<GroupEntity>;
  hops!: FirestoreCollectionHandler<Hop>;
  invitations!: FirestoreCollectionHandler<InvitationEnvelope>;
  lists!: FirestoreCollectionHandler<List>;
  members!: FirestoreCollectionHandler<Member>;
  nodes!: FirestoreCollectionHandler<OrgNode>;
  notifications!: FirestoreCollectionHandler<Notification>;
  solverResults!: FirestoreCollectionHandler<SolverResult>;
  solvers!: FirestoreCollectionHandler<Solver>;
  reminders!: FirestoreCollectionHandler<Reminder>;
  reports!: FirestoreCollectionHandler<Report>;
  responses!: FirestoreCollectionHandler<SurveyResponse>;
  roles!: FirestoreCollectionHandler<Role>;
  tables!: FirestoreCollectionHandler<Table>;
  tags!: FirestoreCollectionHandler<Tag>;
  tasks!: FirestoreCollectionHandler<Task>;
  tenantConfig!: FirestoreCollectionHandler<Config>;
  textwidgets!: FirestoreCollectionHandler<TextWidget>;
  themes!: FirestoreCollectionHandler<Theme>;
  userGroups!: FirestoreCollectionHandler<UserGroup>;
  users!: FirestoreCollectionHandler<User>;
  workflows!: FirestoreCollectionHandler<Workflow>;

  constructor() {
    Object.keys(collectionMap).forEach((collectionName) => {
      const propertyName = Object.keys(collectionRef).find(
        (key) => collectionRef[key as keyof CollectionRef] === collectionName
      ) as keyof CollectionRef | undefined;

      if (!propertyName) {
        log.warn(`No matching property found for collection name: ${collectionName}`);
        return;
      }

      // Dynamically set the instance property

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this as any)[propertyName] = this.collectionManagerFactory.create<
        CollectionMap[keyof CollectionMap]
      >(collectionName as keyof CollectionMap);
    });
  }
}

export const collectionsService = new CollectionsService();
